import React, { useState } from 'react';
import './Noticias.css';
import NewsCard from '../../components/NewsCard/NewsCard';

import Not1Img1 from '../../assets/noticias/noticia1_img1.jpg';
import Not1Img2 from '../../assets/noticias/noticia1_img2.jpg';

const Noticias = () => {
  const [noticias] = useState([
    {
      id: 1,
      content: (
        <div>
          <h2>Confira como foi o Seminário da Cidade!</h2>
          <div className="text-justified paragraph-spaced">
            <p>Na terça-feira, 25 de novembro de 2025, às 19h, aconteceu o Seminário da Cidade, evento que marcou a abertura oficial do Plano Municipal de Saneamento Básico de Consolação para toda a população.</p>
            <p>A equipe técnica da Fundação Theodomiro Santiago, vinculada à Universidade Federal de Itajubá – UNIFEI, apresentou aos participantes o que é o Plano de Saneamento Básico, seus objetivos, diretrizes e a metodologia de trabalho que será adotada em sua elaboração. Também foram explicadas as etapas do processo, o cronograma de desenvolvimento e, principalmente, a importância da participação social em todas as fases.</p>
          </div>

          <div className="images-row">
            <div className="image-with-caption">
              <img src={Not1Img1} alt="Seminário da Cidade"/>
              {/* <div className="image-caption">Legenda da primeira imagem</div> */}
            </div>
            <div className="image-with-caption">
              <img src={Not1Img2} alt="Seminário da Cidade"/>
              {/* <div className="image-caption">Legenda da segunda imagem</div> */}
            </div>
            <div className="images-group-caption">Evento Seminário da Cidade em Consolação - MG.</div>
            <div className="images-caption">Evento Seminário da Cidade em Consolação - MG.</div>
          </div>

          <div className="text-justified paragraph-spaced">
            <p>Durante o encontro, reforçou-se que a população pode contribuir não apenas comparecendo aos eventos, mas também respondendo à pesquisa sobre os serviços de saneamento básico de Consolação, disponível no site oficial e, em breve, distribuída em versão impressa nas escolas, na Prefeitura e no Posto de Saúde Municipal.</p>
            <p>Confira a apresentação abaixo ou acesse a página da Prefeitura de Consolação no Facebook, onde a transmissão completa está disponível.</p>
            <p>
              <a href="https://www.facebook.com/PMConsolacao/videos/1825958764716406/" target="_blank" rel="noopener noreferrer">Seminário da Cidade - Parte 01</a>
              {' '}e{' '}
              <a href="https://www.facebook.com/PMConsolacao/videos/1613395616702655" target="_blank" rel="noopener noreferrer">Seminário da Cidade - Parte 02</a>
            </p>
            <p className="text-bold">Participe e ajude a construir o futuro do saneamento de Consolação!</p>
          </div>
        </div>
      )
    }
  ]);

  return (
    <div className="news-page">
      <section className="page-hero">
        <div className="page-hero__text">
          <span className="page-hero__eyebrow">Notícias</span>
          <p className="page-hero__description">Fique por dentro do que acontece no Plano Municipal de Saneamento Básico.</p>
        </div>
      </section>

      <section className="news-content">
        {noticias.length === 0 ? (
          <div style={{
          textAlign: 'center',
          padding: '4rem 2rem',
          color: '#666',
          fontSize: '1.125rem'
        }}>
          <p>Por enquanto não há notícias disponíveis.</p>
          <p style={{ marginTop: '1rem', fontSize: '1rem' }}>
            Em breve, você encontrará aqui informações sobre o Plano Municipal de Saneamento Básico.
          </p>
          </div>
        ) : (
          noticias.map((noticia) => (
            <NewsCard key={noticia.id} noticia={noticia} />
          ))
        )}
      </section>
    </div>
  );
};

export default Noticias;
